import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="carousel"
export default class extends Controller {
  static targets = ["slide", "area"];

  static values = {
    index: Number,
  };

  connect() {
    this.#initMinIndex();
    this.index = this.minIndex;
  }

  next() {
    this.slideTargets[this.index].scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    this.#incrementIndex();
  }

  #incrementIndex() {
    this.index += 1;
    if (this.index < this.minIndex) this.index = this.minIndex;
    if (this.index + 1 >= this.slideTargets.length) this.index = 0;
  }

  // Find index of first element that is not visible in "areaTarget"
  #initMinIndex() {
    this.minIndex = this.slideTargets.findIndex((element) => {
      return this.areaTarget.clientWidth < element.offsetLeft;
    });
    if (this.minIndex === -1) this.minIndex = 0;
  }
}
